import React from "react";
import ButtonInput from "../../../../components/common/Button/ButtonInput";
import MultipleSelect from "../../../../components/common/MultipleSelect/MultipleSelect";
import CustomTable from "../../../../components/common/Table/CustomTable";
import TextInput from "../../../../components/common/TextInput/TextInput";
import { renderTopupDepositColumns, requestType } from "../constants";

const TopupDeposit = ({
  handleSendTopupButtonClick,
  handleAcceptDepositButtonClick,
  handleCancelTopupButtonClick,
  data,
  loading,
  handleTableChange,
  tablePagination,
  handleEnter,
  pageSizeValue,
  handleOutletButtonClick,
  handleSelectChange,
  handleInputChange,
  selectedRequestType,
}) => {
  return (
    <div className="py-3">
      <div className="d-flex filter-bar filter-bar-2">
        <TextInput
          id={"pageSize"}
          label={"Tampilkan"}
          width={"7%"}
          handleEnter={handleEnter}
          value={pageSizeValue}
          handleChange={handleInputChange}
        />
        <ButtonInput
          id={"outlet"}
          label={"Cabang/Outlet"}
          buttonText={"Nama Cabang"}
          onButtonClick={handleOutletButtonClick}
          variant={"outline-secondary"}
          width={"13%"}
        />
        <MultipleSelect
          id={"requestType"}
          label={"Jenis Permohonan"}
          onSelectChange={handleSelectChange}
          options={requestType}
          value={selectedRequestType}
        />
      </div>

      <CustomTable
        columns={renderTopupDepositColumns(
          handleSendTopupButtonClick,
          handleAcceptDepositButtonClick,
          handleCancelTopupButtonClick
        )}
        data={data}
        loading={loading}
        handleTableChange={handleTableChange}
        pagination={tablePagination}
      />
    </div>
  );
};

export default TopupDeposit;
